/**
 * Settings outside a game — Blockari's `SettingsPage`: the same controls the in-game gear opens, on a page of
 * their own in the shell (the bar above it, the Create | Take dock below), with a close button.
 */

import { el } from '@/ui/hud';
import { SettingsControls, type PauseScreenOptions } from '@/ui/settings';
import { createScreen, TopBar, type TopBarCallbacks } from '@/ui/screens';

export class SettingsScreen {
  readonly root: HTMLElement;
  readonly topBar: TopBar;
  readonly #controls: SettingsControls;

  constructor(
    callbacks: { bar?: TopBarCallbacks; onClose(): void; onHome(): void; onHistory(): void },
    options: PauseScreenOptions = {},
  ) {
    const { screen, panel } = createScreen('settings', true, 'main');
    this.root = screen;
    this.root.setAttribute('aria-label', '21 Wild — settings');
    this.topBar = new TopBar(callbacks.bar ?? { onHome: () => callbacks.onHome(), onHistory: () => callbacks.onHistory() });
    screen.append(this.topBar.root);
    panel.className = 'w21-page';

    const column = el('div', 'w21-column');
    const card = el('div', 'w21-panel w21-settings-page');
    const head = el('div', 'w21-settings-head');
    const close = el('button', 'w21-icon-btn w21-sm') as HTMLButtonElement;
    close.type = 'button';
    close.setAttribute('aria-label', 'Close settings');
    close.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
    close.addEventListener('click', () => callbacks.onClose());
    head.append(el('h2', undefined, 'Settings'), close);
    this.#controls = new SettingsControls(options);
    card.append(head, this.#controls.root);
    column.append(card);
    panel.append(column);
  }

  /** Re-read the mixer, the quality tier and where push stands (they can move while the page is away). */
  show(): void {
    this.#controls.sync();
    this.#controls.paintQuality();
    void this.#controls.syncPush();
  }
}
